import { render, staticRenderFns } from "./BusinessStatusForm.vue?vue&type=template&id=1e87dc54&scoped=true&"
import script from "./BusinessStatusForm.vue?vue&type=script&lang=js&"
export * from "./BusinessStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessStatusForm.vue?vue&type=style&index=0&id=1e87dc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87dc54",
  null
  
)

export default component.exports